<template>
  <div class="characteristics">
    <div class="list">
      <div class="item" v-for="(characteristic, index) in characteristicsList" :key="index">
        <span
          class="subtitle"
          v-if="characteristic.subtitle"
          :class="{ short: characteristics.isShortCharacteristics }"
        >
          {{ characteristic.subtitle }}
        </span>
        <ul class="sublist">
          <li
            class="characteristic"
            :class="{ ['characteristic_one-row']: isShort }"
            v-for="(value, index) in characteristic.values"
            :key="index"
          >
            <MMText font="Body M/Regular Long" color="tertiary" tag="span">{{ value.name }}</MMText>
            <MMText font="Body M/Regular Long">
              <DisclosureText class="value" :rows="6" :text="value.value" :title="value.value" />
            </MMText>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ICharacteristics } from '../../../models/characteristic';
import DisclosureText from '@/shared/ui/DisclosureText.vue';
import { MMText } from '@mm-frontend/mm-web-ui-kit';

interface Props {
  characteristics: ICharacteristics;
  isShort?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isShort: false,
});

const characteristicsList = computed(() => {
  return props.characteristics.list;
});
</script>

<style lang="stylus" scoped>
.characteristics
  font-family 'Inter'

  .title
    font-weight 600
    font-size 28px
    line-height 36px
    letter-spacing -0.021em
    margin 0
    margin-bottom 32px

  .list
    display flex
    flex-wrap wrap

    .item
      margin-top 32px
      width 100%

      &:first-child
        margin-top 0

      .subtitle
        font-size 18px
        font-weight 600
        line-height 24px
        letter-spacing -0.007em
        margin 0

        &.short
          font-size 14px
          line-height 20px
          letter-spacing -0.01em

      .sublist
        display grid
        grid-template-columns 1fr 1fr
        column-gap 56px
        row-gap 12px

        .characteristic
          display grid
          grid-template-columns 1fr 3fr
          flex: 0 1 100%;

          +Media(Desktop, DesktopMax)
            flex: 0 1 50%;

          &_one-row
            flex: 0 1 100%;

          .value
            word-break break-word
            max-width 200px
            padding-left 96px


.show-more
    display inline-block
    margin-top 28px
    color hsla(229, 6%, 57%, 1)
    text-decoration underline
    cursor pointer

.short-title
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: #141415;
  margin-bottom 16px;
</style>
